import { BlockedUserCreationFormProvider } from '@exam-center/blocked-user-creation';
import { NavigateBackLink } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PageHeader } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function AdminBlocklistCreateLayout() {
  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.CREATE}
    >
      <PageHeader
        title='เพิ่มรายชื่อผู้ไม่มีสิทธิ์สอบ'
        linkAdornment={<NavigateBackLink to='/admin/blocklist' />}
      />
      <BlockedUserCreationFormProvider>
        <Outlet />
      </BlockedUserCreationFormProvider>
    </PermissionGuard>
  );
}
